import { __awaiter } from "tslib";
import { InterconsultService } from "@/services/models/interconsult/interconsult";
const moduleInterconsultsWithoutAppointment = {
    namespaced: true,
    state: {
        loading: false,
        tableInterconsultWithoutAppointment: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        filterInterconsults: {
            state: "",
            step: "",
            node: 0,
            step2: "",
            service_node_id: null,
            ges: null,
            patient_id: null,
            is_cosam: false,
            searchRut: null,
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getTableInterconsultWithoutAppointment(state) {
            return state.tableInterconsultWithoutAppointment;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTableInterconsultWithoutAppointment(state, tableInterconsultWithoutAppointment) {
            state.tableInterconsultWithoutAppointment = tableInterconsultWithoutAppointment;
        },
        setPagTableInterconsultWithoutAppointment(state, page) {
            state.tableInterconsultWithoutAppointment.current_page = page;
        },
        setTableInterconsultWithoutAppointmentFilter(state, filter) {
            state.filterInterconsults.state = filter.state;
            state.filterInterconsults.step = filter.step_destino;
            state.filterInterconsults.node = filter.node;
            state.filterInterconsults.step2 = filter.step_origen;
            state.filterInterconsults.diagnostic = filter.diagnostic;
            state.filterInterconsults.request_date_end = filter.request_date_end;
            state.filterInterconsults.request_date_start = filter.request_date_start;
            state.filterInterconsults.origin_node_id = filter.origin_node_id;
            state.filterInterconsults.priority = filter.priority;
            state.filterInterconsults.ges = filter.ges;
            state.filterInterconsults.service_node_id = filter.service_node_id;
            state.filterInterconsults.is_cosam = filter.is_cosam;
            if (filter.searchRut) {
                state.filterInterconsults.searchRut = filter.searchRut.replaceAll(".", "").replaceAll("-", "");
            }
        },
        cleanTableInterconsultWithoutAppointmentFilter(state) {
            state.filterInterconsults.state = null;
            state.filterInterconsults.step = null;
            state.filterInterconsults.node = null;
            state.filterInterconsults.step2 = null;
            state.filterInterconsults.diagnostic = null;
            state.filterInterconsults.request_date_end = null;
            state.filterInterconsults.request_date_start = null;
            state.filterInterconsults.origin_node_id = null;
            state.filterInterconsults.priority = null;
            state.filterInterconsults.ges = null;
            state.filterInterconsults.service_node_id = null;
            state.filterInterconsults.is_cosam = null;
            state.filterInterconsults.searchRut = null;
        },
        setTableInterconsultWithoutAppointmentService(state, service_node_id) {
            state.filterInterconsults.service_node_id = service_node_id;
        },
        setTableInterconsultWithoutAppointmentGes(state, ges) {
            state.filterInterconsults.ges = ges;
        },
        setTableInterconsultWithoutAppointmentPatient(state, patient_id) {
            state.filterInterconsults.patient_id = patient_id;
        },
    },
    actions: {
        getTableInterconsultWithoutAppointment({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                console.log("test 123", state.filterInterconsults);
                const INTERCONSULTS = yield InterconsultService.getFindByStateStepNodeDoesntHaveicPost(state.filterInterconsults, state.tableInterconsultWithoutAppointment.current_page);
                commit("setTableInterconsultWithoutAppointment", INTERCONSULTS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleInterconsultsWithoutAppointment;
